export default {
    customer:{
        logintitle:'계정 로그인',
        email:'메일',
        password:'비밀번호',
        loginbtn:'로그인',
        loginSuccess:'로그인되었습니다',
        otherloginMode:'기타 로그인',
        RechargeCore:'충전 센터',
        RechargeCores:'충전 센터 - U.LU Games',
        AccountsDele:'계정이 삭제 되었습니다.',
        AccountsSeal:'계정이 정지 되었습니다',
        PasswordError:'비밀번호 오류',
        AccountsNotence:'계정을 찾을 수 없습니다',
        EmailFormatError:'이메일 양식을 정확하게 입력해 주세요',
        PlacePassword:'비밀번호를 입력해 주세요',
        PlaceEmail:'메일을 입력해 주세요',
        parameterIncomplete:'데이터 오류',
        Rechargeption:'(충전 설명)',
        Rechargeption2:'충전 설명',
        obtainGameFail:'게임 불러오기에 실패하였습니다, 다시 시도해 주세요.',
        placePayMode:'결제 수단을 선택해 주세요',
    },
    RechargePage:{
        logout:'로그아웃',
        Rechargeccount:'충전 계정',
        game:'게임',
        TheServer:"서버",
        RoleNickname:"닉네임",
        placeChTheSer:"서버를 선택해 주세요",
        PlaceChNickN:"닉네임을 선택해 주세요",
        PayMode:"결제 방식",
        ChoosCommodity:"상품을 선택해 주세요",
        OrderHathair:"미완성 주문입니다.",
        HelpConCusSer:"도움이 필요 하시면 고객센터를 찾아주세요.cs@ulugame.com",
        GlobalException:"전역 데이터 오류",
        good:"확인",
        OrderCompleted:"주문에 성공하셨습니다",
        SuccessBuy:"구매 성공하셨습니다",
        Ordercancelled:'결제가 취소되었습니다.',

        Databaseerror:"데이터에 오류가 발생하셨습니다",
        operror:"데이터 베이스 오류",
        Invaildlogin:'로그인 오류 다시 시도해 주세요',
        Emailwasbinded:'이미 연동한 메일입니다',
        Codeerror:'인증 코드 오류',
        bindedalready:'이미 연동한 SNS 계정 입니다',
        ULUaccount:"해당 계정은 ULU풀랫폼 계정 연동을 하셨습니다",
        Codeinvalid:'인증 코드 유효기간이 지났습니다',
        haveRegist:"이미 있는 계정입니다. 로그인으로 진행해 주세요",
        Requestfrequently:"요정 지연 중, 잠시 후 시도해 주세요",
        notRegister:"미 등록 계정입니다.",
        oneBind:"모든 연동 해제전 메일 연동 우선 진행해 주세요",
        idError:"정확한 계정을 입력해주세요",
        Noorvicnleund:'서버 및 캐릭터가 조회 되지 않습니다.',
        gamesempty:'게임이 비어 있음',
        determin:'확인',
        Rechargeonfirmation:'결제 내역',
        Confirmwingarormation:'충전 내역을 확인해 주세요',
        BuyGoods:'구매 상품',
        cancel:'취소',

        RoleNickID:'캐릭터ID',
        PlaceNickID:'캐릭터ID를 입력해주세요.',
        check:'검증',
        PlaceCheckID:'캐릭터ID를 검증해주세요.',
        CheckSuccess:'검증 완료, 캐릭터명은 :',
        VerificationFailed:'검증에 실패하였습니다. 존재하지 않는 캐릭터입니다.',
        SystemError:'시스템 에러',
        InterfaceException:'연결에 실패하였습니다.',
        FrequentVisits:'방문히 너무 빈번합니다.',
        NetworkAnomaly:'인터넷 불안정',

        PleLoginFirst:'먼저 게임 아이디로 로그인해주세요',
        RecharRoleInformation:'결제 캐릭터 정보',
        TotalAmount:'총금액',
        ImmediatePayment:'즉시 결제',
        PleaseVerifyServer:'서버를 확인해주세요',
        PayRole:'결제 캐릭터',
        PlsselectRole:'캐릭터를 선택해주세요',

        // 新增
        NoorvicnleundPleaseCreate:'캐릭터를 찾지 못했습니다, 게임 내에서 먼저 캐릭터를 생성하십시오',
        CommoditySettlement:'상품 결제',
        TopupRole:'충전 캐릭터',
        Server:'서버',
        product:'상품',
        Price:'가격',
        quantity:'수량',
        Limited:'한정 구매',
        favorable:'할인',
        SelectCoupon:'쿠폰을 선택하세요',
        NoCouponsAvailable:'사용 가능한 쿠폰 없음',
        PaymentMethod:'결제방식',
        total:'합계',
        CompleteThePayment:'결제 완료 후',
        points:'포인트 획득할 수 있습니다',
        ImmediatePaymentNew:'결제하기',
        BuyNow:'즉시 구매',
        UserTermsOfService:'이용자 서비스 약관',
        PrivacyPolicy:'개인정보 정책',
        AboutUs:'회사 소개',
        full:'',
        ThePurchaseLimitOtherItems:'더 이상 구매할 수 없습니다. 기타 상품을 구매해 주시길 바랍니다',
        InTheQuery:'확인중',

        expire:'만료',
        placeChTheRole:'캐릭터를 선택해주세요',
    },
}
